<div *ngIf="loading()" class="spinner-overlay">
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
</div>
